(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sk-promo-note"] && !Shopify.designMode) return;
  try {
    (function () {
    function fill() {
      var note = document.querySelector('[data-sk-promo-note]');
      var cfgEl = document.querySelector('[data-sk-promo-config]');
      if (!note || !cfgEl) return;
      var cfg;
      try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
      if (!cfg || !cfg.show || !cfg.code) { note.hidden = true; return; }
      note.querySelector('[data-sk-promo-label]').textContent = cfg.label || '';
      note.querySelector('[data-sk-promo-text]').textContent = cfg.text || '';
      note.querySelector('[data-sk-promo-code]').textContent = cfg.code;
      var btn = note.querySelector('[data-sk-promo-copy]');
      btn.setAttribute('data-sk-promo-copy', cfg.code);
      btn.setAttribute('aria-label', 'Copy discount code ' + cfg.code);
      note.hidden = false;
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fill);
    } else {
      fill();
    }
    // Theme editor: re-fill when the header section is re-rendered after an edit
    document.addEventListener('shopify:section:load', fill);
  })();

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sk-promo-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-sk-promo-copy');
    var out = btn.querySelector('.sk-promo-note__copied');
    function done(ok) {
      if (!out) return;
      out.textContent = ok ? 'Copied' : 'Select to copy';
      setTimeout(function () { out.textContent = ''; }, 1800);
    }
    if (code && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () { done(true); }, function () { done(false); });
    } else {
      done(false);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sk-ship-nudge"] && !Shopify.designMode) return;
  try {
    (function () {
    function money(cents) {
      var s = (cents / 100).toFixed(2);
      return '$' + (s.slice(-3) === '.00' ? s.slice(0, -3) : s);
    }

    function qtyFor(el) {
      var scope = el.closest('.buy-buttons-block, product-form-component, form') || el.parentElement || document;
      var input = scope.querySelector('input[name="quantity"]') || document.querySelector('product-form-component input[name="quantity"]');
      var q = input ? parseInt(input.value, 10) : 1;
      return q > 0 ? q : 1;
    }

    function render(el) {
      var T = parseInt(el.dataset.threshold, 10);
      var F = parseInt(el.dataset.fee, 10);
      var C = parseInt(el.dataset.cart, 10) || 0;
      var P = parseInt(el.dataset.price, 10);
      var out = el.querySelector('[data-sk-ship-nudge-text]');
      if (!out || !(T > 0) || !(P > 0)) { el.hidden = true; return; }

      var noun = el.dataset.noun || 'item';
      var Q = qtyFor(el);
      var html;

      // Only speak up when ONE of this item gets them to free shipping (owner's call,
      // 2026-10-13). Nothing once the cart already ships free, nothing when it would
      // take two or more.
      if (C >= T || C + P < T) {
        el.dataset.state = C >= T ? 'free' : 'far';
        el.hidden = true;
        return;
      }
      // Lead with the SAME "$X away" the cart drawer bar shows (counted from the cart as
      // it is now). Counting from after this item was added gave a different number
      // than the cart and confused shoppers.
      var lead = C > 0
        ? '<strong>You\'re ' + money(T - C) + ' away from FREE shipping.</strong> '
        : '<strong>Orders over ' + money(T) + ' ship FREE.</strong> ';
      // (the ", so it really costs you $X" ending was removed at the owner's request, 2026-10-13)
      html = lead + (Q === 1 ? 'Add this ' + noun : 'Add these') + ' and you save ' + money(F) + ' on shipping.';
      el.dataset.state = 'unlock';
      out.innerHTML = html;
      el.hidden = false;
    }

    function all() {
      return Array.prototype.slice.call(document.querySelectorAll('[data-sk-ship-nudge]'));
    }

    function renderAll() { all().forEach(render); }

    var refreshing = false;
    var again = false;
    function refreshCart() {
      if (!all().length) return;
      // a request already in flight may predate this change: run once more after it
      if (refreshing) { again = true; return; }
      refreshing = true;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      // /cart is never served from cache (the home page's ?sections= came back null in testing)
      fetch(root + 'cart?section_id=sk-ship-nudge-data&_=' + Date.now(), { cache: 'no-store' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          var m = html.match(/data-sk-ship-nudge-data>([^<]+)</);
          if (!m) return;
          var cents = JSON.parse(m[1]).cart;
          all().forEach(function (el) { el.dataset.cart = cents; });
          renderAll();
        })
        .catch(function () {})
        .then(function () {
          refreshing = false;
          if (again) { again = false; refreshCart(); }
        });
    }

    // Measured on the live store: right when cart:update fires, a fresh render can still
    // return the cart from BEFORE the add (it caught up ~150ms later). Reading once at
    // 150ms left the note one step behind, so read after a longer pause and once more.
    document.addEventListener('cart:update', function () {
      setTimeout(refreshCart, 450);
      setTimeout(refreshCart, 1800);
    });
    document.addEventListener('quantity-selector:update', function () { setTimeout(renderAll, 0); });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'quantity') renderAll();
    });
    document.addEventListener('variant:update', function (e) {
      var d = e.detail || {};
      var v = d.resource;
      if (!v || !(v.price > 0)) return;
      var pid = d.data && d.data.productId;
      all().forEach(function (el) {
        if (!pid || String(pid) === el.dataset.productId) el.dataset.price = v.price;
      });
      renderAll();
      // the theme re-renders parts of the form after this event; fill again once it settles
      setTimeout(renderAll, 300);
    });
    // back/forward cache restores an old page: the cart may have changed since
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderAll);
    else renderAll();
  })();
  } catch(e) { console.error(e); }
})();

})();
